import _regeneratorRuntime from '/app/node_modules/babel-runtime/regenerator';
import _asyncToGenerator from '/app/node_modules/babel-runtime/helpers/asyncToGenerator';
import _extends from '/app/node_modules/babel-runtime/helpers/extends';
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ProgressLine from './progress-line';
import BtnFilters from './btn-filters';
import { mapState, mapGetters } from 'vuex';

export default {
    components: {
        ProgressLine: ProgressLine,
        BtnFilters: BtnFilters
    },
    data: function data() {
        return {
            noContent: false,
            loading: true,
            departmentsFilter: this.$store.getters['dashboard/filters/departments'],
            productsTypeFilter: this.$store.getters['dashboard/filters/productsType'],
            provinceSelect: this.$store.getters['dashboard/filters/province'],
            btnFilters: false,
            menu: this.$store.state.dashboard.filters.menuActivatorProcess
        };
    },

    computed: _extends({}, mapState({
        affiliationsProcess: function affiliationsProcess(state) {
            return state.dashboard.table.affiliationsProcess || [];
        }
    }), mapGetters({
        totalItems: 'dashboard/table/totalItemsProcess',
        menuActivator: 'dashboard/filters/menuActivatorProcess'
    }), {
        fullTable: function fullTable() {
            return this.affiliationsProcess.length;
        },
        date: function date() {
            for (var i = 0; i < this.affiliationsProcess.length; i++) {
                var result = this.$moment(this.affiliationsProcess[i].RegisterDate, 'YYYY-MM-DDTHH:mm:ss.SSSZ').format('DD/MM/YY');
                return result;
            }
        },
        existsAnyNotification: function existsAnyNotification() {
            return this.affiliationsProcess.filter(function (ap) {
                return ap.HasNotification === 1;
            }).length > 0;
        }
    }),
    methods: {
        setsearch: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(data) {
                return _regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                this.$store.dispatch('dashboard/table/search', data);

                            case 1:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function setsearch(_x) {
                return _ref.apply(this, arguments);
            }

            return setsearch;
        }(),
        search: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(term) {
                var data;
                return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                data = {
                                    type: 'Process'
                                };

                                this.$store.commit('dashboard/table/setTerm', term);
                                this.setsearch(data);

                            case 3:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function search(_x2) {
                return _ref2.apply(this, arguments);
            }

            return search;
        }(),
        pagination: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(val) {
                var data;
                return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                data = {
                                    type: 'Process',
                                    limit: val.pageSize,
                                    paginationNumber: val.pageNumber
                                };

                                this.$store.commit('dashboard/table/setPagination', val);
                                this.setsearch(data);

                            case 3:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function pagination(_x3) {
                return _ref3.apply(this, arguments);
            }

            return pagination;
        }(),
        progressWidth: function progressWidth(step) {
            var width = void 0;
            var startIndex = 2;
            var totalSteps = 11;

            if (step <= startIndex) {
                width = step * 50 / startIndex;
            } else {
                var numberSteps = totalSteps - startIndex;
                var index = step - startIndex;

                width = 50 + 50 / numberSteps * index;
            }
            return width;
        },
        exportTable: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
                return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                this.$store.dispatch('dashboard/table/exportTable', {
                                    type: 'Process',
                                    idChannel: this.$store.state.dashboard.details.idChannel || -1,
                                    idTeam: this.$store.state.dashboard.details.idTeam || -1,
                                    idSeller: this.$store.state.dashboard.details.idSellerByTeam || -1
                                });

                            case 1:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function exportTable() {
                return _ref4.apply(this, arguments);
            }

            return exportTable;
        }(),
        toDetailProcess: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(data) {
                return _regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                this.$store.commit('affiliations/form/finishAffiliation', 1);
                                // console.log("Data: ", JSON.stringify(data));

                                if (this.$isSeller() == true || this.$isSupervisor() == true) {
                                    _context5.next = 3;
                                    break;
                                }

                                return _context5.abrupt('return');

                            case 3:
                                _context5.prev = 3;

                                if (!data.IdNotification) {
                                    _context5.next = 7;
                                    break;
                                }

                                _context5.next = 7;
                                return this.$store.dispatch('notification/markAsRead', data.IdNotification);

                            case 7:

                                this.$emit('leaving');
                                this.$router.push({
                                    path: '/new-affiliation',
                                    query: {
                                        idAffiliation: data.IdAffiliation,
                                        idAffiliationProcess: data.IdAffiliationProcess
                                    }
                                });
                                _context5.next = 14;
                                break;

                            case 11:
                                _context5.prev = 11;
                                _context5.t0 = _context5['catch'](3);

                                this.$controlMessage(_context5.t0);

                            case 14:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this, [[3, 11]]);
            }));

            function toDetailProcess(_x4) {
                return _ref5.apply(this, arguments);
            }

            return toDetailProcess;
        }(),
        setMenuActivator: function setMenuActivator() {
            this.$store.commit('dashboard/filters/setMenuActivatorTableProcess', true);
        }
    },
    watch: {
        menuActivator: function menuActivator(val) {
            this.menu = val;
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dashboard/affiliations-process.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dashboard/affiliations-process.vue
// module chunks = 0 5